const B_1 = [
    {
        title: '招标文件',
        path: '/bidding/projectflow/fabiao/zbFile/list'
    }
]
export default {
    path: 'zbFile',
    component: () => import(/*webpackChunkName: 'bidding-kai-getoffer'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/list'),
            meta: {
                title: '招标文件列表',
                bread: B_1
            },
        },{
            path:"form",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/form'),
            meta: {
                title: '上传招标文件',
                bread: B_1
            },
        },{
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/detail'),
            meta: {
                title: '招标文件详情',
                bread: B_1
            },
        },{
            path:"nodedetailEdit",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/dialog/nodedetailEdit'),
            meta: {
                title: '评审项修改',
                bread: B_1
            },
        },{
            path:"bysForm",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/bys/form'),
            meta: {
                title: '添加补遗书',
                bread: B_1
            },
        },{
            path:"bysdetail",
            component: () => import('@views/bidding/views/project-flow/fa/zb-file/bys/bysdetail'),
            meta: {
                title: '补遗书详情',
                bread: B_1
            },
        },
    ]
}